import { render } from "./VehicleTripsView.vue?vue&type=template&id=386070a8"
import script from "./VehicleTripsView.vue?vue&type=script&lang=js"
export * from "./VehicleTripsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__